import { render, staticRenderFns } from "./member-welfare.vue?vue&type=template&id=5dbbda03&scoped=true"
import script from "./member-welfare.vue?vue&type=script&lang=js"
export * from "./member-welfare.vue?vue&type=script&lang=js"
import style0 from "./member-welfare.vue?vue&type=style&index=0&id=5dbbda03&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbbda03",
  null
  
)

export default component.exports